import { UsersTable } from '@/modules/employerUsers/pages/components/UsersTable/UsersTable'

export function EmployerUsersShell() {
  return <UsersTable />
}
